export default __webpack_public_path__ + "static/media/vire23.4da7c230.jpg";